export default {
  name: "slideProfileSection",
  data() {
    return {
      activeClassProfile: 'col-md-12 profile-menu-element active',
      fullName: this.$store.getters.getUserInfo.firstName + ' ' + this.$store.getters.getUserInfo.lastName
    };
  },
  // async created() {
  //   this.createTable();
  // },
  computed: {
    currentPage() {
      return this.$router.app._route.fullPath;
    },
  },
  methods: {
    test(){
      console.log(this.$router.app._route.fullPath)
    },
    signOut() {
      console.log("ee");
      window.localStorage.removeItem("Giftstore-U");
      window.localStorage.removeItem("Giftstore-T");
      this.$store.commit("setUserInfo", {});
      console.log("store", this.$store.getters.getUserInfo);
      this.$router.push({ name: "loginandregister" });
    },
    // createTable() {
    //   for (var i = 0; i <= 5; i++) {
    //     if (i == 0) {
    //       this.classTable[i] = "col-md-12 profile-menu-element active";
    //     } else {
    //       this.classTable[i] = "col-md-12 profile-menu-element";
    //     }
    //   }
    // },
    // changeColor(nb) {
    //   for (var i = 0; i <= 5; i++) {
    //     this.classTable[i] = "col-md-12 profile-menu-element";
    //   }
    //   this.classTable[nb] = "col-md-12 profile-menu-element active";
    //   console.log(this.classTable,nb)

    // },
  },
};
